import { Resource } from 'kolibri/apiResource';

export default new Resource({
  name: 'facilityusername',
  namespace: 'kolibri.plugins.user_auth',
  idKey: 'username',
});
